import React from 'react';

/**
 * Compact OMC mark — renders the FULL official logo (mark + wordmark + tagline)
 * at the requested pixel HEIGHT, letting the width grow naturally.
 * No cropping — the entire logo artwork is visible.
 */
export default function OMCMarkSquare({ size = 40, className = '' }) {
  // Transparent logo — bg removed so it sits cleanly on any color surface.
  const src = size <= 64 ? '/brand/omc-logo-trans-120.png' : '/brand/omc-logo-trans-240.png';
  return (
    <img
      src={src}
      alt="Ozark Mountain Construction"
      height={size}
      style={{ height: size, width: 'auto', display: 'block' }}
      className={className}
      decoding="async"
    />
  );
}
